import { QueryOptions, useGetAccounts } from '../../../api/lending/lapiHooks';
import { selectLatestIwocaPayFormalOffer } from '../helpers/formalOffer';

export function useLatestFormalOffer(queryOptions?: QueryOptions) {
  const { fetchAccounts, accounts, loadingAccounts } =
    useGetAccounts(queryOptions);

  const latestFormalOffer = accounts
    ? selectLatestIwocaPayFormalOffer({ data: accounts })
    : null;

  return {
    fetchLatestFormalOffer: fetchAccounts,
    latestFormalOffer: latestFormalOffer,
    loadingLatestFormalOffer: loadingAccounts,
  };
}
